import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { queryClient } from './lib/queryClient';
import ErrorBoundary from './components/ErrorBoundary';
import { setupApiAuth } from './lib/setupApiAuth';

// Install the global JWT interceptors for fetch + axios. From this point on,
// any request to environment.apiURL automatically carries the Bearer token
// when one is stored. Other origins are left alone.
setupApiAuth();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
serviceWorkerRegistration.register({
  // Fase 5.B: corrected SW update flow.
  //
  // Previous version did three things in the wrong order:
  //   1) await registration.unregister()  -> kills the active SW
  //   2) waiting.postMessage(SKIP_WAITING) -> sent to a SW that no longer exists
  //   3) window.location.reload()         -> manual reload
  // Combined with the duplicate controllerchange listener in index.html,
  // this produced two reloads (one manual, one automatic) on every update,
  // and on slow connections could leave the user without a SW for a moment.
  //
  // Correct flow:
  //   1) Tell the waiting SW to skip its waiting phase (it becomes the
  //      active SW). The browser fires a controllerchange event.
  //   2) The single guarded reloadOnce listener in serviceWorkerRegistration
  //      reloads the page exactly once.
  // No unregister, no manual reload here.
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  },
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
